export const getActiveCvObj = (fcanvas) => fcanvas && (fcanvas.getActiveGroup() || fcanvas.getActiveObject());
export const getActiveFcanvas = () => box.sel('maker->editing_canvas');
